import React from "react";
import Typography from "@mui/material/Typography";
import Layout from "../../layout/layout";
import { Box, Button, Card, CardContent, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import ProtectedPage from "../ProtectedPage";

const DeliveryManagement = () => {
    const navigate = useNavigate();

    const body = (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Delivery Management
            </Typography>
            <Typography variant="body1" paragraph>
                Manage delivery-related operations and user information
            </Typography>

            <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4}>
                    <Card
                        sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.02)",
                                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                            },
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1 }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                Area User Search
                            </Typography>
                            <Typography>
                                Search for users by area to manage deliveries efficiently
                            </Typography>
                        </CardContent>
                        <Box sx={{ p: 2 }}>
                            <Button
                                variant="contained"
                                startIcon={<SearchIcon />}
                                onClick={() => navigate("/delivery-management/area-search")}
                                fullWidth
                            >
                                Search By Area
                            </Button>
                        </Box>
                    </Card>
                </Grid>

                {/* Additional cards for future delivery management features can be added here */}
            </Grid>
        </Box>
    );

    return (
        <ProtectedPage>
            <Layout title="Delivery Management" body={body} />
        </ProtectedPage>
    );
};

export default DeliveryManagement;
